export const formatNumber = (value: number, decimals: number = 2, removeZeros: boolean = false): string => {
    const valueFixed = value.toFixed(decimals)
    const parts = valueFixed.split('.')

    const integerPart = parseInt(parts[0]).toLocaleString('ru-RU')
    const fractionalPart = removeZeros ? parseFloat(valueFixed).toString().split('.')[1] : parts[1]

    return parts.length > 1 && fractionalPart ? `${integerPart}.${fractionalPart}` : integerPart
}
